var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSymbolTypograohyMedium(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_219_4778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.32031 29.9375C5.32031 16.6827 16.0655 5.9375 29.3203 5.9375H77.3203C90.5751 5.9375 101.32 16.6827 101.32 29.9375V77.9375C101.32 91.1923 90.5751 101.938 77.3203 101.938H29.3203C16.0655 101.938 5.32031 91.1923 5.32031 77.9375V29.9375Z",
    fill: "url(#paint0_linear_219_4778)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3264 71.9134C72.0597 71.9134 75.5507 69.8771 77.0539 66.7254H77.1507V69.9255C77.1507 71.1377 77.9748 71.9375 79.1143 71.9375C80.278 71.9375 81.1022 71.1377 81.1022 69.8284V53.6588C81.1022 48.3739 77.2234 44.9557 71.0657 44.9557C66.5082 44.9557 62.7022 46.9678 61.3204 50.0951C61.0536 50.7012 60.8597 51.283 60.8597 51.7921C60.8597 52.8588 61.6598 53.5618 62.7022 53.5618C63.4536 53.5618 64.0355 53.2709 64.3992 52.5921C65.7568 49.78 67.8172 48.4709 70.9689 48.4709C74.7507 48.4709 77.0052 50.58 77.0052 53.9739V56.0588L69.1749 56.4951C63.0415 56.8345 59.6235 59.6709 59.6235 64.1799C59.6235 68.8104 63.187 71.9134 68.3264 71.9134ZM69.3203 68.5438C66.0477 68.5438 63.8173 66.7497 63.8173 64.0831C63.8173 61.5133 65.8779 59.7921 69.684 59.5497L77.0052 59.0891V61.6587C77.0052 65.5135 73.5871 68.5438 69.3203 68.5438ZM27.5748 71.7436C28.8596 71.7436 29.49 71.2588 29.9505 69.9012L33.0778 61.3437H47.3809L50.5082 69.9012C50.9687 71.2588 51.599 71.7436 52.8598 71.7436C54.1445 71.7436 54.9689 70.9679 54.9689 69.7557C54.9689 69.3436 54.8962 68.9558 54.702 68.4467L43.3324 38.1678C42.7748 36.689 41.7809 35.9375 40.2294 35.9375C38.7263 35.9375 37.7081 36.6648 37.1748 38.1436L25.8051 68.471C25.6111 68.9799 25.5384 69.3679 25.5384 69.78C25.5384 70.9922 26.3142 71.7436 27.5748 71.7436ZM34.2657 57.6588L40.1566 41.3436H40.2779L46.1688 57.6588H34.2657Z",
    fill: "url(#paint1_linear_219_4778)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_219_4778",
    x: 0.320312,
    y: 0.9375,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_219_4778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_219_4778",
    x1: 53.3203,
    y1: 5.9375,
    x2: 53.3203,
    y2: 101.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_219_4778",
    x1: 53.321,
    y1: 35.9375,
    x2: 53.321,
    y2: 71.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9EBFF",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolTypograohyMedium);
export default __webpack_public_path__ + "static/media/symbol-typograohy-medium.db48d89bf53ea66f9abbb4dbecf69331.svg";
export { ForwardRef as ReactComponent };